import React, { useState, useMemo, useEffect, useRef } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { Badge } from 'react-bootstrap';
import moment from 'moment-timezone';
import { OrdersFetchAPI } from '../api/Orders';

/* ─────────────────────────────────────────────────────────
   CSS — inyectado una sola vez en <head>
   Prefijo: .bq-  (btnquote)
───────────────────────────────────────────────────────── */
const BQ_CSS = `

`;

/* ── ICONS ── */
const IcoReceipt = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <polyline points="14 2 14 8 20 8" />
    <line x1="16" y1="13" x2="8" y2="13" />
    <line x1="16" y1="17" x2="8" y2="17" />
    <line x1="10" y1="9" x2="8" y2="9" />
  </svg>
);
const IcoLock = () => (
  <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2">
    <rect x="3" y="11" width="18" height="11" rx="2" />
    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
  </svg>
);
const IcoUnlock = () => (
  <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2">
    <rect x="3" y="11" width="18" height="11" rx="2" />
    <path d="M7 11V7a5 5 0 0 1 9.9-1" />
  </svg>
);
const IcoArrow = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
    <line x1="5" y1="12" x2="19" y2="12" />
    <polyline points="12 5 19 12 12 19" />
  </svg>
);
const IcoPin = () => (
  <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2">
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
    <circle cx="12" cy="10" r="3" />
  </svg>
);

/* ─────────────────────────────────────────────────────────
   COMPONENT — lógica 100% original, solo visual nuevo
───────────────────────────────────────────────────────── */
const Btnquote = ({ ordersQuote, setOrdersQuote }) => {
  const [clientData, setClientData] = useState(() => {
    if (localStorage.getItem('client') != null && localStorage.getItem('client') != undefined && localStorage.getItem('client') != '') {
      return JSON.parse(localStorage.getItem('client'))
    } else {
      return null
    }
  })

  let machine = "";
  let business = "";
  let branchoffice = "";
  let token = ""

  const navigate = useNavigate();
  const [orderData, setOrderData] = useState([]);
  // minDate: 3 meses atrás a las 00:00:00, maxDate: hoy a las 23:59:59
  const [minDate, setMinDate] = useState(
    moment().tz('America/Bogota').subtract(3, 'months').startOf('day').format('YYYY-MM-DDTHH:mm:ss.SSSZ')
  );
  const [maxDate, setMaxDate] = useState(
    moment().tz('America/Bogota').endOf('day').format('YYYY-MM-DDTHH:mm:ss.SSSZ')
  );

  const [quoteLocal, setQuoteLocal] = useState(() => {
    if (localStorage.getItem('quoteData') != null && localStorage.getItem('quoteData') != undefined && localStorage.getItem('quoteData') != '') {
      return JSON.parse(localStorage.getItem('quoteData'))
    } else {
      return null
    }
  })
  // Fetch order quote details
  const getOrderQuote = async () => {
    try {
      const responsePending = await OrdersFetchAPI.getOrdersTempPendingByClienId(business.code, branchoffice.code, minDate, maxDate, 0, 0, machine.id, 0, token, clientData.id, true)
      //console.log("response quote", responsePending.data.temp_orders);
      setOrderData(responsePending.data.temp_orders);

      if (setOrdersQuote !== undefined) {
        setOrdersQuote(responsePending.data.temp_orders)
      }

    } catch (err) {
      setOrderData([])
      //console.log(err);
    }
  }

  const getTemporalOrderById = async (order) => {
    try {
      let token = undefined;
      const response = await OrdersFetchAPI.getTempOrderById(order._id, token);
      let dataOrder = response.data.pre_order
      navigate(`/order/quote/${dataOrder.code}`)

    } catch (err) {
      //console.log(err);
      //ErrorAlert("", "Error de consulta", "error")
    }
  }

  useEffect(() => {
    if (localStorage.getItem("branchoffice") != "" && localStorage.getItem("branchoffice") != undefined && localStorage.getItem("machine") != "" && localStorage.getItem("machine") != undefined) {
      token = undefined;
      branchoffice = JSON.parse(localStorage.getItem('branchoffice'))
      machine = JSON.parse(localStorage.getItem('machine'));
      business = JSON.parse(localStorage.getItem("business"));
      //console.log("aaaaaah");
      if (localStorage.getItem('guestClient') != null && localStorage.getItem('guestClient') != undefined && localStorage.getItem('guestClient') != '') {
        if (localStorage.getItem('guestClient') === 0 || localStorage.getItem('guestClient') === "0") { getOrderQuote() }
      }

    } else {
      //console.log("nope");
    }
  }, []);

  useEffect(() => { }, [orderData]);

  const [showPopover, setShowPopover] = useState(false);
  const popoverRef = useRef(null);

  // Cerrar el popover si se hace clic fuera
  useEffect(() => {
    function handleClickOutside(event) {
      if (popoverRef.current && !popoverRef.current.contains(event.target)) {
        setShowPopover(false);
      }
    }
    if (showPopover) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showPopover]);

  /* inject CSS once */
  useEffect(() => {
    const id = "bq-styles";
    if (!document.getElementById(id)) {
      const el = document.createElement("style");
      el.id = id; el.textContent = BQ_CSS;
      document.head.appendChild(el);
    }
  }, []);

  const totalCount = orderData.length > 0 ? orderData.length : quoteLocal ? 1 : 0;

  /* ── RENDER ──────────────────────────────────────────── */
  if (orderData.length === 0 && quoteLocal === null) return null;


  return (
    <div
      ref={popoverRef}
      className='bq-trigger-fixed-3'    >
      {/* ── POPOVER PANEL ── */}
      {showPopover && (
        <div className="bq-panel">

          {/* header */}
          <div className="bq-panel-head">
            <div>
              <div className="bq-panel-title">Tus Cotizaciones</div>
              <div className="bq-panel-sub">{totalCount} {totalCount === 1 ? 'cotización' : 'cotizaciones'}</div>
            </div>
          </div>

          {/* lista desde API */}
          {orderData.length > 0 && (
            <ul className="bq-list">
              {orderData.map((order, idx) => (
                <li key={order.id || idx}>
                  <div className="bq-card">

                    {/* badge estado */}
                    <div className={`bq-card-badge ${order.is_authorized ? 'bq-badge-closed' : 'bq-badge-open'}`}>
                      {order.is_authorized
                        ? <><IcoLock /> Cotización cerrada</>
                        : <><IcoUnlock /> Cotización abierta</>}
                    </div>

                    {/* datos */}
                    <div className="bq-card-rows">
                      <div className="bq-card-row">
                        <span className="bq-card-row-label">Items</span>
                        <span className="bq-card-row-val">{order.groups.length}</span>
                      </div>
                      <div className="bq-card-row">
                        <span className="bq-card-row-label">Fecha</span>
                        <span className="bq-card-row-val">
                          {order.createdAt ? order.createdAt.substring(0, 10) : 'N/A'}
                        </span>
                      </div>
                      <div className="bq-card-row">
                        <span className="bq-card-row-label">Total</span>
                        <span className="bq-card-row-val brand">
                          {order.total ? `$${order.total}` : 'N/A'}
                        </span>
                      </div>
                    </div>

                    {/* CTA */}
                    <button className="bq-go-btn" onClick={() => getTemporalOrderById(order)}>
                      Ir a cotización <IcoArrow />
                    </button>

                  </div>
                </li>
              ))}
            </ul>
          )}

          {/* divider entre API y local */}
          {orderData.length > 0 && quoteLocal && <div className="bq-divider" />}

          {/* cotización local */}
          {quoteLocal && (
            <ul className="bq-list">
              <li>
                <div className="bq-card">

                  {/* label local */}
                  <div className="bq-card-local-label">
                    <IcoPin /> Guardada localmente
                  </div>

                  {/* badge estado */}
                  <div className={`bq-card-badge ${quoteLocal.is_authorized ? 'bq-badge-closed' : 'bq-badge-open'}`}>
                    {quoteLocal.is_authorized
                      ? <><IcoLock /> Cotización cerrada</>
                      : <><IcoUnlock /> Cotización abierta</>}
                  </div>

                  {/* datos */}
                  <div className="bq-card-rows">
                    <div className="bq-card-row">
                      <span className="bq-card-row-label">Items</span>
                      <span className="bq-card-row-val">{quoteLocal.groups.length}</span>
                    </div>
                    <div className="bq-card-row">
                      <span className="bq-card-row-label">Fecha</span>
                      <span className="bq-card-row-val">
                        {quoteLocal.createdAt ? quoteLocal.createdAt.substring(0, 10) : 'N/A'}
                      </span>
                    </div>
                    <div className="bq-card-row">
                      <span className="bq-card-row-label">Total</span>
                      <span className="bq-card-row-val brand">
                        {quoteLocal.total ? `$${quoteLocal.total}` : 'N/A'}
                      </span>
                    </div>
                  </div>

                  {/* CTA */}
                  <button className="bq-go-btn" onClick={() => getTemporalOrderById(quoteLocal)}>
                    Ir a cotización <IcoArrow />
                  </button>

                </div>
              </li>
            </ul>
          )}

        </div>
      )}

      {/* ── TRIGGER BUTTON ── */}
      <button
        className="bq-trigger "
        onClick={() => setShowPopover((v) => !v)}
      >
        <div className="bq-trigger-icon position-relative">
          <IcoReceipt />

          <span className="bq-trigger-count position-absolute top-0 start-100 translate-middle d-lg-none d-block">{totalCount}</span>
        </div>

        <span className="bq-trigger-label">
          Cotizaciones
        </span>
        <div className='d-none d-lg-block'>  <span className="bq-trigger-count  ">{totalCount}</span></div>

      </button>

    </div>
  );
};

export default Btnquote;